export default __webpack_public_path__ + "static/media/slick.2630a3e3.svg";